module.exports = __webpack_public_path__ + "images/kameror-optik.e9404018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/kameror-optik.jpg
// module id = ad722196
// module chunks = 10 37